import { Controller } from '@hotwired/stimulus'
import { Chart, DoughnutController, ArcElement, LinearScale } from 'chart.js'
Chart.register(ArcElement, DoughnutController, LinearScale);

export default class extends Controller {
    connect() {
        function fireInViewport(el) {
            if (el) {
                let elCoordinates = el.getBoundingClientRect()
                return (
                    elCoordinates.top + elCoordinates.height >= 0 && elCoordinates.top <= (window.innerHeight || document.documentElement.clientHeight)
                )
            }
        }
        function animateValue(el, start, end, duration, unit) {
            if (start === end) return;
            let range = end - start;
            let current = start + (end - Math.floor(end))
            let increment = end > start ? 1 : -1;
            let stepTime = Math.abs(Math.floor(duration / range))
            let obj = el;
            let timer = setInterval(function () {
               current += increment;
               obj.innerHTML = `${(Number.isInteger(current) ? current : current.toFixed(1)) + (unit ? unit : '')}`
               if (current >= end) {
                  clearInterval(timer)
               }
            }, stepTime);
         }

         let circleChart = false
         function circleDiagram() {
            const circleItems = document.querySelectorAll('.stat-circle__item')
            if (circleItems && fireInViewport(document.querySelector('.stat-circle')) && circleChart === false) {

               circleItems.forEach(item => {
                  let circle = item.querySelector('.diag-circle')
                  let valArr = []
                  item.querySelectorAll('.stat-circle__percent-value').forEach(val => {
                     let percentVal = val.getAttribute('data-circle-diagram')
                     valArr.push(percentVal)
                     animateValue(val, 0, percentVal, 700, '%')
                  })

                  circleChart = new Chart(circle, {
                     // The type of chart we want to create
                     type: 'doughnut',

                     // The data for our dataset
                     data: {
                        datasets: [{
                           weight: 0,
                           borderWidth: 28,
                           borderColor: ['#FC491E', '#FD9A27'],
                           data: valArr,
                        }]
                     },

                     // Configuration options go here
                     options: {
                        responsive: true,
                     }
                  })
               })
            }
            return false
         }


         // line diagram
         let lineDiagramFlag = false
         function lineDiagram() {
            const diagItems = document.querySelectorAll('.stat-line__item')

            if (diagItems && fireInViewport(document.querySelector('.stat-line')) && lineDiagramFlag === false) {

               const diag = {
                  arrValue: [],
                  bigestValue: undefined,
                  percent: undefined,
                  colors: ['#F5D8B5', '#F5CA97', '#FABC76', '#FD9A27', '#FC491E'] // Если добавитя ещё одна линия в списке нужно добавить ещё один цвет (цвета идут просто по порядку от самого бледного до темного)
               }
               diagItems.forEach(diagItem => {
                  diag.arrValue.push(Number(diagItem.querySelector('.stat-line__diagram').getAttribute('data-line-diagram')))
               })
               diag.bigestValue = Math.max(...diag.arrValue)
               diag.arrValue = diag.arrValue.sort()
               diag.arrValue.forEach((val, i) => {
                  animateValue(document.querySelector(`[data-line-diagram="${val}"]`).nextElementSibling, 0, val, 1000, '%')

                  diag.percent = val / diag.bigestValue * 100
                  document.querySelector(`[data-line-diagram="${val}"]`).querySelector('.stat-line__diagram-body').style = `width: ${diag.percent}%; background: ${diag.colors[i]};`
               })
               lineDiagramFlag = true
            }

         }
         this.diagramRun = () => {
            lineDiagram()
            circleDiagram()
         }
         if (document.querySelector('.stat-circle') || document.querySelector('.stat-line')) {
            this.diagramRun()
            window.addEventListener('scroll', this.diagramRun)

         }
    }

    disconnect() {
        window.removeEventListener('scroll', this.diagramRun)
    }
}
